// Space and Enter Keys are used to accept Inputs
const isAcceptKey = function (e) {
    if (e.code === 'Space' || e.code === 'Enter' || e.keyCode === 13 || e.keyCode === 32) {
        return true;
    }
    return false;
};
export default isAcceptKey;
